// import React from 'react';
// import { useNavigate } from 'react-router-dom';
// import { Box, Typography, Button, Container, Paper} from '@mui/material';
// import { styled, keyframes } from '@mui/system';
// import ArrowBackIcon from '@mui/icons-material/ArrowBack';
// import HomeIcon from '@mui/icons-material/Home';
// import RefreshIcon from '@mui/icons-material/Refresh';
// import { createTheme } from '@mui/material/styles';
// import { ThemeProvider } from '@mui/material/styles';

// const theme = createTheme({
//     palette: {
//       primary: {
//         main: '#1976d2',
//       },
//       secondary: {
//         main: '#fff',
//       },
//       // other properties
//     },
//     // other customizations
//   });
// const gradient = keyframes`
//   0% { background-position: 0% 50%; }
//   50% { background-position: 100% 50%; }
//   100% { background-position: 0% 50%; }
// `;

// const float = keyframes`
//   0%, 100% { transform: translateY(0) rotate(0deg); }
//   50% { transform: translateY(-20px) rotate(180deg); }
// `;

// const shimmer = keyframes`
//   0% { background-position: -200% 50%; }
//   100% { background-position: 200% 50%; }
// `;

// const Background = styled(Box)(({ theme }) => ({
//   position: 'absolute',
//   inset: 0,
//   background: `linear-gradient(to bottom right, ${theme.palette.primary.main}20, transparent, ${theme.palette.secondary.main}20)`,
//   animation: `${gradient} 15s ease infinite`,
//   backgroundSize: '400% 400%',
// }));

// const FloatingShape = styled(Box)({
//   position: 'absolute',
//   width: 32,
//   height: 32,
//   borderRadius: '50%',
//   backgroundColor: 'rgba(255, 255, 255, 0.05)',
//   backdropFilter: 'blur(4px)',
//   animation: `${float} 8s ease-in-out infinite`,
// });

// const GlassCard = styled(Paper)(({ theme }) => ({
//   backdropFilter: 'blur(16px)',
//   backgroundColor: 'rgba(255, 255, 255, 0.1)',
//   borderRadius: theme.shape.borderRadius * 2,
//   padding: theme.spacing(4),
//   border: '1px solid rgba(255, 255, 255, 0.1)',
// }));

// const ShimmerText = styled(Typography)(({ theme }) => ({
//   backgroundImage: `linear-gradient(to right, ${theme.palette.primary.main}, ${theme.palette.secondary.main}, ${theme.palette.primary.main})`,
//   WebkitBackgroundClip: 'text',
//   WebkitTextFillColor: 'transparent',
//   backgroundSize: '200% auto',
//   animation: `${shimmer} 3s linear infinite`,
// }));

// const ActionButton = styled(Button)(({ theme, variant }) => ({
//   padding: theme.spacing(1.5, 3),
//   borderRadius: theme.shape.borderRadius * 2,
//   textTransform: 'none',
//   ...(variant === 'contained' && {
//     background: `${theme.palette.primary.main}`,
//     '&:hover': {
//       boxShadow: `0 0 20px ${theme.palette.primary.main}66`,
//     },
//   }),
//   ...(variant === 'outlined' && {
//     backdropFilter: 'blur(4px)',
//     backgroundColor: 'rgba(255, 255, 255, 0.1)',
//     borderColor: 'rgba(255, 255, 255, 0.1)',
//     color: theme.palette.common.black,
//     '&:hover': {
//       backgroundColor: 'rgba(255, 255, 255, 0.2)',
//     },
//   }),
// }));

// const ModernNotFound = () => {
//   const navigate = useNavigate();

//   return (
//     <ThemeProvider theme={theme}>
//     <Box
//       sx={{
//         minHeight: '100vh',
//         width: '100%',
//         bgcolor: 'background.default',
//         display: 'flex',
//         alignItems: 'center',
//         justifyContent: 'center',
//         p: 2,
//         position: 'relative',
//         overflow: 'hidden',
//       }}
//     >
//       <Background />

//       {[...Array(20)].map((_, i) => (
//         <FloatingShape
//           key={i}
//           sx={{
//             left: `${Math.random() * 100}%`,
//             top: `${Math.random() * 100}%`,
//             animationDelay: `${Math.random() * 5}s`,
//             transform: `scale(${Math.random() * 0.5 + 0.5})`,
//           }}
//         />
//       ))}

//       <Container maxWidth="lg" sx={{ position: 'relative', zIndex: 1 }}>
//         <Box sx={{ textAlign: 'center', mb: 4 }}>
//           <ShimmerText variant="h1" sx={{ fontSize: { xs: '120px', sm: '200px' }, fontWeight: 'bold' }}>
//             404
//           </ShimmerText>
//         </Box>

//         <GlassCard>
//           <Typography variant="h4" color="text.primary" gutterBottom>
//             Page not found
//           </Typography>
//           <Typography variant="body1" color="text.secondary" paragraph>
//             The page you're looking for doesn't exist or has been moved.
//             Check the URL or try navigating back.
//           </Typography>

//           <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, gap: 2, justifyContent: 'center', mt: 4 }}>
//             <ActionButton
//               variant="outlined"
//               startIcon={<ArrowBackIcon />}
//               onClick={() => navigate(-1)}
//             >
//               Go Back
//             </ActionButton>
//             <ActionButton
//               variant="contained"
//               startIcon={<HomeIcon />}
//               onClick={() => navigate('/')}
//             >
//               Home Page
//             </ActionButton>
//             <ActionButton
//               variant="outlined"
//               startIcon={<RefreshIcon />}
//               onClick={() => window.location.reload()}
//             >
//               Reload
//             </ActionButton>
//           </Box>
//         </GlassCard>
//       </Container>
//     </Box></ThemeProvider>
//   );
// };

// export default ModernNotFound;

import React, { useEffect, useState } from "react";
import bgImage from "../../assets/img/notFound_bg.svg";
import bgImageMobile from "../../assets/img/notFound_bg_mobile.svg";
import ButtonAppBar from "components/Navbars/navBar";
import {
  Box,
  Button,
  Divider,
  Grid,
  InputAdornment,
  Snackbar,
  styled,
  TextField,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { useNavigate } from "react-router-dom";
import NewAppBar from "components/Navbars/AppBar";
import { NewSearchButton } from "components/Buttons/Buttons";
import arrowLeft from "../../assets/img/arrow_back_icon.svg";
import { NewCreateOfferButton } from "components/Buttons/Buttons";
import { NewPostButton } from "components/Buttons/Buttons";
import colors from "colors/color";
import Footer from "views/Landing/Footer";
import { useTranslation } from "react-i18next";
const SearchBox = styled(Box)(({ theme }) => ({
  display: "flex",
  gap: theme.spacing(0),
  backgroundColor: "white",
  padding: theme.spacing(0.5),
  borderRadius: "50px",
  boxShadow: "0 4px 20px 0px rgba(0, 0, 0, 0.08)",
  width: "100%",
  maxWidth: "500px",
  margin: "0 auto",
  zIndex: 2,
  overflow: "hidden",
  [theme.breakpoints.down("sm")]: {
    flexDirection: "column",
    gap: theme.spacing(1),
    maxWidth: "100%"
  },
}));
const StyledTextField = styled(TextField)(({ theme }) => ({
  fontFamily: "Poppins",
  textTransform: "none",
  fontSize: "30px",
  "& .MuiOutlinedInput-root": {
    backgroundColor: "white",
    borderRadius: 0,
    "& fieldset": {
      borderColor: "transparent",
      borderRadius: 0,
    },
    "&:hover fieldset": {
      borderColor: "transparent",
    },
    "&.Mui-focused fieldset": {
      borderColor: "transparent",
    },
  },
}));
const SearchButton = styled(Button)(({ theme }) => ({
  borderRadius: "100px",
  height: "48px",
  padding: "5% 15%",
  marginLeft: theme.spacing(1),
  marginRight: theme.spacing(0.5),
  backgroundColor: "#0085FF",
  fontSize: "13px",
  color: "white",
  whiteSpace: "nowrap",
  "&:hover": {
    backgroundColor: theme.palette.primary.dark,
    boxShadow: "0 4px 12px rgba(0, 102, 255, 0.3)",
  },
}));
function PageNotFound() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [isAuth, setIsAuth] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [snackbarState, setSnackbarState] = useState({
    open: false,
    message: "",
    severity: "info",
  });
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const showSnackbar = (message, severity = "info") => {
    setSnackbarState({
      open: true,
      message,
      severity,
    });
  };

  const handleCloseSnackbar = () => {
    setSnackbarState(prev => ({ ...prev, open: false }));
  };

  useEffect(() => {
    setIsAuth(!!localStorage.getItem("accessToken"));
  }, []);

  return (
    <>
      <NewAppBar  />
      <Box 
        sx={{
          minHeight: "100vh",
          width: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          pt: { xs: "15%", sm: "10%", md: "5%" },
          pb: { xs: "10%", sm: "5%" },
          px: { xs: 2, sm: 4 },
          position: "relative",
          mt:4
        }}
      >
        <Box
          sx={{
            width: "100%",
            height: "100%",
            position: "absolute",
            zIndex: -1,
            backgroundImage: `url(${isMobile ? bgImageMobile : bgImage})`,
            backgroundSize: { xs: "150%", sm: "contain" },
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            top: 0,
            left: 0,
          }}
        />
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: "100%",
            maxWidth: "1200px",
            margin: "0 auto",
            zIndex: 1,
          }}
        >
          <Grid container justifyContent="center">
            <Grid item xs={12} sm={10} md={8} lg={6} sx={{ textAlign: "center" }}>
              <Typography
                variant="h1"
                color={colors.primary}
                sx={{
                  fontWeight: "600",
                  fontFamily: "Kontora",
                  fontSize: { xs: "60px", sm: "70px", md: "80px" },
                  mb: { xs: 2, sm: 3 }
                }}
              >
                {t('pageNotFound.error')}
              </Typography>
              <Typography
                variant="body1"
                color="#00000080"
                sx={{ 
                  fontFamily: "Poppins", 
                  fontWeight: 200, 
                  fontSize: { xs: "16px", sm: "18px" },
                  px: { xs: 2, sm: 0 }
                }}
              >
                {t('pageNotFound.message1')}
              </Typography>
              <Typography
                variant="body1"
                color="#00000080"
                sx={{ 
                  fontFamily: "Poppins", 
                  fontWeight: 200, 
                  fontSize: { xs: "16px", sm: "18px" },
                  mb: { xs: 3, sm: 4 }
                }}
              >
                {t('pageNotFound.message2')}
              </Typography>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <NewPostButton 
                  onClick={() => navigate("/landing")} 
                  sx={{
                    mt: 2,
                    width: "100%",
                    maxWidth: { xs: "250px", sm: "300px" },
                    py: { xs: 1, sm: 1.5 },
                    "&:hover": {
                      backgroundColor: "transparent",
                      borderColor: "transparent",
                      color: colors.primary,
                    }
                  }}
                >
                  <img src={arrowLeft} alt="arrow-left" />
                  <Typography 
                    sx={{ 
                      fontFamily: "Poppins", 
                      fontSize: { xs: "12px", sm: "14px" }, 
                      fontWeight: "400", 
                      color: colors.primary, 
                      marginLeft: "10px" 
                    }}
                  >
                    {t('pageNotFound.backToHome')}
                  </Typography>
                </NewPostButton>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Box>
      <Footer />
      <Snackbar
        open={snackbarState.open}
        autoHideDuration={snackbarState.severity === "success" ? 2000 : 3000}
        onClose={handleCloseSnackbar}
        message={
          <span style={{ color: "black" }}>
            {snackbarState.message}
          </span>
        }
        sx={{
          "& .MuiSnackbarContent-root": {
            backgroundColor: "rgba(255, 255, 255, 0)",
            color: "black",
            borderRadius: "50px",
            backdropFilter: "blur(3px)",
            boxShadow: "0 4px 30px rgba(0, 0, 0, 0.5)",
          },
        }}
      />
    </>
  );
}

export default PageNotFound;
